import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import {Box} from "@mui/material";

import CustomButton from "components/CustomButton";

ExportButton.propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
};

function ExportButton({disabled = false, onClick = () => {}}) {
    return (
        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            <CustomButton
                disabled={disabled}
                variant="contained"
                color="blue"
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    marginLeft: "12px"
                }}
                onClick={onClick}
            >
                <FileDownloadOutlinedIcon style={{ fontSize: 18 }} />
                <FormattedMessage id="dashboard.header.export" />
            </CustomButton>
        </Box>
    );
}

export default ExportButton;
